/**
 * @fileoverview gRPC-Web generated client stub for bish
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: planning/service.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as planning_service_pb from '../planning/service_pb'; // proto import: "planning/service.proto"


export class PlanningClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorArchiveCurrentSprint = new grpcWeb.MethodDescriptor(
    '/bish.Planning/ArchiveCurrentSprint',
    grpcWeb.MethodType.UNARY,
    planning_service_pb.ArchiveCurrentSprintRequest,
    planning_service_pb.ArchiveCurrentSprintResponse,
    (request: planning_service_pb.ArchiveCurrentSprintRequest) => {
      return request.serializeBinary();
    },
    planning_service_pb.ArchiveCurrentSprintResponse.deserializeBinary
  );

  archiveCurrentSprint(
    request: planning_service_pb.ArchiveCurrentSprintRequest,
    metadata?: grpcWeb.Metadata | null): Promise<planning_service_pb.ArchiveCurrentSprintResponse>;

  archiveCurrentSprint(
    request: planning_service_pb.ArchiveCurrentSprintRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: planning_service_pb.ArchiveCurrentSprintResponse) => void): grpcWeb.ClientReadableStream<planning_service_pb.ArchiveCurrentSprintResponse>;

  archiveCurrentSprint(
    request: planning_service_pb.ArchiveCurrentSprintRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: planning_service_pb.ArchiveCurrentSprintResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/bish.Planning/ArchiveCurrentSprint',
        request,
        metadata || {},
        this.methodDescriptorArchiveCurrentSprint,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/bish.Planning/ArchiveCurrentSprint',
    request,
    metadata || {},
    this.methodDescriptorArchiveCurrentSprint);
  }

  methodDescriptorCreateTask = new grpcWeb.MethodDescriptor(
    '/bish.Planning/CreateTask',
    grpcWeb.MethodType.UNARY,
    planning_service_pb.CreateTaskRequest,
    planning_service_pb.CreateTaskResponse,
    (request: planning_service_pb.CreateTaskRequest) => {
      return request.serializeBinary();
    },
    planning_service_pb.CreateTaskResponse.deserializeBinary
  );

  createTask(
    request: planning_service_pb.CreateTaskRequest,
    metadata?: grpcWeb.Metadata | null): Promise<planning_service_pb.CreateTaskResponse>;

  createTask(
    request: planning_service_pb.CreateTaskRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: planning_service_pb.CreateTaskResponse) => void): grpcWeb.ClientReadableStream<planning_service_pb.CreateTaskResponse>;

  createTask(
    request: planning_service_pb.CreateTaskRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: planning_service_pb.CreateTaskResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/bish.Planning/CreateTask',
        request,
        metadata || {},
        this.methodDescriptorCreateTask,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/bish.Planning/CreateTask',
    request,
    metadata || {},
    this.methodDescriptorCreateTask);
  }

  methodDescriptorEditTask = new grpcWeb.MethodDescriptor(
    '/bish.Planning/EditTask',
    grpcWeb.MethodType.UNARY,
    planning_service_pb.EditTaskRequest,
    planning_service_pb.Task,
    (request: planning_service_pb.EditTaskRequest) => {
      return request.serializeBinary();
    },
    planning_service_pb.Task.deserializeBinary
  );

  editTask(
    request: planning_service_pb.EditTaskRequest,
    metadata?: grpcWeb.Metadata | null): Promise<planning_service_pb.Task>;

  editTask(
    request: planning_service_pb.EditTaskRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: planning_service_pb.Task) => void): grpcWeb.ClientReadableStream<planning_service_pb.Task>;

  editTask(
    request: planning_service_pb.EditTaskRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: planning_service_pb.Task) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/bish.Planning/EditTask',
        request,
        metadata || {},
        this.methodDescriptorEditTask,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/bish.Planning/EditTask',
    request,
    metadata || {},
    this.methodDescriptorEditTask);
  }

  methodDescriptorGetSprintDetails = new grpcWeb.MethodDescriptor(
    '/bish.Planning/GetSprintDetails',
    grpcWeb.MethodType.UNARY,
    planning_service_pb.GetSprintDetailsRequest,
    planning_service_pb.GetSprintDetailsResponse,
    (request: planning_service_pb.GetSprintDetailsRequest) => {
      return request.serializeBinary();
    },
    planning_service_pb.GetSprintDetailsResponse.deserializeBinary
  );

  getSprintDetails(
    request: planning_service_pb.GetSprintDetailsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<planning_service_pb.GetSprintDetailsResponse>;

  getSprintDetails(
    request: planning_service_pb.GetSprintDetailsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: planning_service_pb.GetSprintDetailsResponse) => void): grpcWeb.ClientReadableStream<planning_service_pb.GetSprintDetailsResponse>;

  getSprintDetails(
    request: planning_service_pb.GetSprintDetailsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: planning_service_pb.GetSprintDetailsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/bish.Planning/GetSprintDetails',
        request,
        metadata || {},
        this.methodDescriptorGetSprintDetails,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/bish.Planning/GetSprintDetails',
    request,
    metadata || {},
    this.methodDescriptorGetSprintDetails);
  }

  methodDescriptorGetTask = new grpcWeb.MethodDescriptor(
    '/bish.Planning/GetTask',
    grpcWeb.MethodType.UNARY,
    planning_service_pb.GetTaskRequest,
    planning_service_pb.Task,
    (request: planning_service_pb.GetTaskRequest) => {
      return request.serializeBinary();
    },
    planning_service_pb.Task.deserializeBinary
  );

  getTask(
    request: planning_service_pb.GetTaskRequest,
    metadata?: grpcWeb.Metadata | null): Promise<planning_service_pb.Task>;

  getTask(
    request: planning_service_pb.GetTaskRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: planning_service_pb.Task) => void): grpcWeb.ClientReadableStream<planning_service_pb.Task>;

  getTask(
    request: planning_service_pb.GetTaskRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: planning_service_pb.Task) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/bish.Planning/GetTask',
        request,
        metadata || {},
        this.methodDescriptorGetTask,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/bish.Planning/GetTask',
    request,
    metadata || {},
    this.methodDescriptorGetTask);
  }

  methodDescriptorListMyTasks = new grpcWeb.MethodDescriptor(
    '/bish.Planning/ListMyTasks',
    grpcWeb.MethodType.UNARY,
    planning_service_pb.ListMyTasksRequest,
    planning_service_pb.ListMyTasksResponse,
    (request: planning_service_pb.ListMyTasksRequest) => {
      return request.serializeBinary();
    },
    planning_service_pb.ListMyTasksResponse.deserializeBinary
  );

  listMyTasks(
    request: planning_service_pb.ListMyTasksRequest,
    metadata?: grpcWeb.Metadata | null): Promise<planning_service_pb.ListMyTasksResponse>;

  listMyTasks(
    request: planning_service_pb.ListMyTasksRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: planning_service_pb.ListMyTasksResponse) => void): grpcWeb.ClientReadableStream<planning_service_pb.ListMyTasksResponse>;

  listMyTasks(
    request: planning_service_pb.ListMyTasksRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: planning_service_pb.ListMyTasksResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/bish.Planning/ListMyTasks',
        request,
        metadata || {},
        this.methodDescriptorListMyTasks,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/bish.Planning/ListMyTasks',
    request,
    metadata || {},
    this.methodDescriptorListMyTasks);
  }

  methodDescriptorListMySprints = new grpcWeb.MethodDescriptor(
    '/bish.Planning/ListMySprints',
    grpcWeb.MethodType.UNARY,
    planning_service_pb.ListMySprintsRequest,
    planning_service_pb.ListMySprintsResponse,
    (request: planning_service_pb.ListMySprintsRequest) => {
      return request.serializeBinary();
    },
    planning_service_pb.ListMySprintsResponse.deserializeBinary
  );

  listMySprints(
    request: planning_service_pb.ListMySprintsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<planning_service_pb.ListMySprintsResponse>;

  listMySprints(
    request: planning_service_pb.ListMySprintsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: planning_service_pb.ListMySprintsResponse) => void): grpcWeb.ClientReadableStream<planning_service_pb.ListMySprintsResponse>;

  listMySprints(
    request: planning_service_pb.ListMySprintsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: planning_service_pb.ListMySprintsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/bish.Planning/ListMySprints',
        request,
        metadata || {},
        this.methodDescriptorListMySprints,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/bish.Planning/ListMySprints',
    request,
    metadata || {},
    this.methodDescriptorListMySprints);
  }

}

